import { makeAutoObservable } from 'mobx';

const KEY_SOUND = 'skvoz:sound';
const KEY_HAPTICS = 'skvoz:haptics';

function readBool(key: string, defaultVal: boolean): boolean {
  const v = localStorage.getItem(key);
  if (v === 'true') return true;
  if (v === 'false') return false;
  return defaultVal;
}

export class PrefsStore {
  sound: boolean;
  haptics: boolean;

  constructor() {
    this.sound = readBool(KEY_SOUND, true);
    this.haptics = readBool(KEY_HAPTICS, true);
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setSound(val: boolean) {
    this.sound = val;
    localStorage.setItem(KEY_SOUND, String(val));
  }

  setHaptics(val: boolean) {
    this.haptics = val;
    localStorage.setItem(KEY_HAPTICS, String(val));
  }
}
